import 'bootstrap-table';
import 'simplebar';
import accordion from './modules/accordion';
import archive from './modules/archive';
import bootstrapTable from './modules/bootstrap-table';
import comments from './modules/comments';
import header from './modules/header';
import postArchive from './modules/post-archive';
import sidebar from './modules/sidebar';
import tabs from './modules/tabs';
import youtubeVideo from './modules/youtube-video';

( function ( $ ) {
    'use strict';

    $( function() {
        accordion.init();
        archive.init();
        bootstrapTable.init();
        comments.init();
        header.init();
        postArchive.init();
        sidebar.init();
        tabs.init();
        youtubeVideo.init();
    } );

} )( jQuery );
